import { Shift, ShiftCreateRequest, ShiftUpdateRequest } from '../../types/app/shifts.types';
import { api } from '../core/api';

export const getShiftList = () => api.get<Shift[]>('Shift/GetList').then((res) => res.data);

export const getShift = (id: number) =>
  api.get<Shift>(`Shift/GetItem/?id=${id}`).then((res) => res.data);

export const updateShift = (data: ShiftUpdateRequest) =>
  api.put(`Shift/UpdateItem`, data).then((res) => res.data);

export const createShift = (data: ShiftCreateRequest) =>
  api.post(`Shift/CreateItem`, data).then((res) => res.data);

export const deleteShift = (id: number) => api.delete<Shift>(`Shift/DeleteItem/?id=${id}`).then();
